export default "__VITE_ASSET__19Vs7sg0__"